import React from "react"
import Heading from "../Heading/Heading"

const Involvement = () => {
	return (
		<div className='container-lg'>
			<div className='our-mission row justify-content-center align-items-center py-5'>
				<Heading main='our involvement' />
				<div className='inner-content h5 font-weight-light' >
					<p className='mb-0 text-center' >
						Project Mritkala, provides these potters with a platform to deal with clients virtually. 
                        We have created a website to exhibit the product catalogues of different vendors. With no 
                        stress of haggling, these handcrafted products are sold at reasonable prices and are ordered
                        by a click of a button. With our stimulation and continual orders, these potter communities
                        will be urged to utilise their tacit knowledge for the upliftment of the community.
					</p>
				</div>
			</div>
		</div>
	)
}

export default Involvement;
